import { render } from "./AFlatButton.vue?vue&type=template&id=cb04903a&scoped=true"
import script from "./AFlatButton.vue?vue&type=script&lang=js"
export * from "./AFlatButton.vue?vue&type=script&lang=js"

import "./AFlatButton.vue?vue&type=style&index=0&id=cb04903a&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb04903a"]])

export default __exports__